/*
 *
 * <CheckItem
 *   checkboxClassname={String}
 *   disabled={boolean}
 *   checked={boolean}
 *   selectAllItems={boolean}
 *   name={String}
 *   label={String}
 *   onChange={function}
 * />
 */
import React, { PureComponent } from "react";
import Checkbox from "material-ui/Checkbox";

class CheckItem extends PureComponent {

	constructor(props) {
		super(props);
    let { name='', checked=false, selectAllItems=false } = this.props;
		this.state = {
			checkedItem: checked || selectAllItems,
			name: name.toString()
		};
		this.onChange = this.onChange.bind(this);
	}

  componentWillReceiveProps(nextProps) {
    let { checked, selectAllItems } = nextProps;
    if (selectAllItems === true || selectAllItems === false) {
      this.setState({
        checkedItem: selectAllItems
      });
    } else if(checked === true || checked === false) {
      this.setState({
        checkedItem: checked
      });
    }
  }

	onChange(event) {
		let name = event.target.name;
		let checked = event.target.checked;
		this.setState({
			checkedItem: checked
		});
    this.props.onChange(name, checked);
	}

  render() {
    return (
      <Checkbox
        disabled={this.props.disabled}
        name={this.state.name}
        checked={this.state.checkedItem}
        className={this.props.checkboxClassname}
        onCheck={this.onChange}
        label={this.props.label}
      />
    );
  }

}

export default CheckItem;



// WEBPACK FOOTER //
// ./src/components/CheckList/CheckItem.js